export const NO_WAITLIST_COPY =
  'No waitlist exists on this stage yet. Create a Waitlist promo in Promos and it appears in the picker above.';

export const PROMO_LIST_FAILED_COPY =
  'The waitlist promo list did not load, so no waitlist could be resolved. Retry; if it persists, check Promos.';

/** Every svc admin route answers 404 `NO_WAITLIST` ("No waitlist is open.")
 *  when the call carries no ?waitlistId= and the registry holds no current or
 *  upcoming waitlist. That is an empty stage, not an outage. */
export const isNoWaitlistError = err => err?.response?.data?.error?.code === 'NO_WAITLIST';

/** Name the failure the service actually gave. A bare "may not be deployed"
 *  hid a plain 404 NO_WAITLIST behind an outage story (2026-09-17). */
export const loadFailureCopy = err => {
  if (isNoWaitlistError(err)) return NO_WAITLIST_COPY;
  const status = err?.response?.status;
  const code = err?.response?.data?.error?.code;
  const detail = status ? ` (HTTP ${status}${code ? ` ${code}` : ''})` : '';
  return `Failed to load the waitlist${detail}. Retry; if it persists, the service may not be deployed for this stage yet.`;
};
